import * as app from './app/redux'
import * as i18n from './i18n/redux'
import * as api from './api/redux'
import * as recipe from './recipe/redux'
import * as recipes from './recipes/redux'
import * as recipesByTag from './recipesbytag/redux'
import * as onboarding from './onboarding/redux'
import * as settings from './settings/redux'
import * as switchcourse from './switchcourse/redux'
import * as user from './user/redux'
import * as quizz from './quizz/redux'
import * as quizzResults from './quizzresults/redux'
import * as quizzResult from './quizzresult/redux'
import * as quizzLanding from './quizzlanding/redux'
import * as eventLanding from './eventlanding/redux'
import * as eventDetail from './eventdetail/redux'
import * as planning from './planning/redux'
import * as planninghistory from './planninghistory/redux'
import * as earlierplanning from './earlierplanning/redux'
import * as plan from './plan/redux'

export const actions = {
  app: app.actions,
  api: api.actions,
  i18n: i18n.actions,
  recipe: recipe.actions,
  recipes: recipes.actions,
  recipesByTag: recipesByTag.actions,
  onboarding: onboarding.actions,
  settings: settings.actions,
  switchcourse: switchcourse.actions,
  user: user.actions,
  quizz: quizz.actions,
  quizzResults: quizzResults.actions,
  quizzResult: quizzResult.actions,
  quizzLanding: quizzLanding.actions,
  eventLanding: eventLanding.actions,
  eventDetail: eventDetail.actions,
  planning: planning.actions,
  planninghistory: planninghistory.actions,
  earlierplanning: earlierplanning.actions,
  plan: plan.actions,
}

export const selectors = {
  app: app.selectors,
  api: api.selectors,
  i18n: i18n.selectors,
  recipe: recipe.selectors,
  recipes: recipes.selectors,
  recipesByTag: recipesByTag.selectors,
  onboarding: onboarding.selectors,
  settings: settings.selectors,
  switchcourse: switchcourse.selectors,
  user: user.selectors,
  quizz: quizz.selectors,
  quizzResults: quizzResults.selectors,
  quizzResult: quizzResult.selectors,
  quizzLanding: quizzLanding.selectors,
  eventLanding: eventLanding.selectors,
  eventDetail: eventDetail.selectors,
  planning: planning.selectors,
  planninghistory: planninghistory.selectors,
  earlierplanning: earlierplanning.selectors,
  plan: plan.selectors,
}

export const reducers = {
  app: app.reducer,
  api: api.reducer,
  i18n: i18n.reducer,
  recipe: recipe.reducer,
  recipes: recipes.reducer,
  recipesByTag: recipesByTag.reducer,
  onboarding: onboarding.reducer,
  settings: settings.reducer,
  switchcourse: switchcourse.reducer,
  user: user.reducer,
  quizz: quizz.reducer,
  quizzResults: quizzResults.reducer,
  quizzResult: quizzResult.reducer,
  quizzLanding: quizzLanding.reducer,
  eventLanding: eventLanding.reducer,
  eventDetail: eventDetail.reducer,
  planning: planning.reducer,
  planninghistory: planninghistory.reducer,
  earlierplanning: earlierplanning.reducer,
  plan: plan.reducer,
}
